import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

export const useGetValidationTableUiStateForReport = () => {
    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);
    return {
        activityCodes: globalFilterData?.activityCodes,
        milestoneFragnet: globalFilterData?.milestoneFragnet,
        tags: globalFilterData?.tags,
        wbs: globalFilterData?.wbs,
    };
};
